import Vue from 'vue';
import Vuetify, { VAutocomplete } from 'vuetify/lib';
import it from 'vuetify/src/locale/it';
import { matchesItemWords } from '@/helpers/textSearch';

Vue.use(Vuetify);

// Ricerca a parole in tutti i menu a tendina con ricerca, come negli altri
// campi "cerca" del portale (vedi helpers/textSearch.ts). Vuetify 2 non ha
// default globali per i prop: si cambia il default del prop `filter` di
// VAutocomplete, che VCombobox eredita perche' non lo ridefinisce. Un menu
// con un `:filter` suo lo scavalca come prima.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(VAutocomplete as any).options.props.filter.default = matchesItemWords;

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        // Colori del marchio Syndesia (dai file ufficiali ORIZZONTALE.pdf / PACCHETTO.pdf):
        // navy #212F50 e magenta #D6007F. Il magenta e' un accento, non va usato per
        // superfici estese.
        primary: '#212F50',
        secondary: '#46526D',
        accent: '#D6007F',
        error: '#FF5252',
        info: '#68abad',
        success: '#4CAF50',
        warning: '#FFC107',

        taskDisabled: '#616161', // grey darken-2
        taskCompleted: '#8BC34A', // light-green

        taskDisabledBackground: '#E0E0E0',
        taskSelectedBackground: '#FFF9C4',
        taskAlternativeSelectedBackground: '#F3E5F5',
        taskCompletedBackground: '#E8F5E9',
        taskErrorBackground: '#FFCDD2',

        childUnassigneBackground: '#F5F5F5', // grey lighten-4
        childOpenBackground: '#FFF3E0', // orange lighten-5
        childNewBackground: '#E3F2FD', // blue lighten-5

        statusNew: '#2196F3', // blue
        statusCancelled: '#9E9E9E', // grey
        statusRejected: '#F44336', // red
        statusOpen: '#FF9800', // orange
        statusClosed: '#9E9E9E', // grey
        statusResolved: '#4CAF50', // green
        // Pallini e icone di uno stato "fatto" (Progetto, Iter, DICO, documenti...).
        // Usavano `primary` e col navy del marchio erano diventati blu
        // (OwlCaveLabs/syndesia-l2c-support#21). Stesso verde degli incarichi
        // assegnati (`green` di Vuetify); il testo bianco sta in App.vue.
        statusDone: '#4CAF50',

        testingOutcomeOrangeBackground: '#FFE0B2', // orange lighten-4
      },
    },
  },
  lang: {
    locales: { it },
    current: 'it',
  },
});
